<template>
  <v-dialog v-model="localShow" max-width="500px" persistent>
    <v-card>
      <v-card-title class="primary white--text">
        {{ $t('scorecard_modal_title') }}
      </v-card-title>

      <v-card-text class="pa-6">
        <div v-if="reservation" class="mb-6">
          <h4 class="mb-3">{{ $t('detalles') }}</h4>

          <v-list dense>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t('fecha') }}</v-list-item-title>
                <v-list-item-subtitle>{{ formatDate(reservation.date_played) }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>{{ $t('cancha') }}</v-list-item-title>
                <v-list-item-subtitle>{{ reservation.course_name || 'Sin especificar' }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="reservation.display_user">
              <v-list-item-content>
                <v-list-item-title>{{ $t('jugador') }}</v-list-item-title>
                <v-list-item-subtitle>{{ reservation.display_user }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>

          <v-divider class="my-4"></v-divider>

          <v-alert
            v-if="hasAgreement"
            type="info"
            outlined
            class="mb-4"
          >
            <div class="font-weight-bold mb-2">{{ $t('scorecard_has_agreement') }}</div>
            <div class="text-caption mb-3">{{ $t('scorecard_coordinator_info') }}</div>

            <div v-if="agreement" class="agreement-info">
              <div class="field">
                <strong>{{ agreement.coordinator_name }}</strong>
              </div>
              <div class="field">
                <a :href="`mailto:${agreement.coordinator_email}`">
                  {{ agreement.coordinator_email }}
                </a>
              </div>
              <div class="field">
                <a :href="`tel:${agreement.coordinator_phone}`">
                  {{ agreement.coordinator_phone }}
                </a>
              </div>
            </div>
          </v-alert>

          <v-alert
            v-if="error"
            type="error"
            dismissible
            @input="error = null"
          >
            {{ error }}
          </v-alert>
        </div>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="closeDialog">
          {{ $t('cancelar') }}
        </v-btn>
        <v-btn
          color="primary"
          :loading="downloading"
          @click="handleDownload"
        >
          <v-icon left>mdi-download</v-icon>
          {{ $t('download_scorecard') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'DownloadScorecardModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    reservation: {
      type: Object,
      default: null
    },
    agreement: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      downloading: false,
      error: null
    }
  },
  computed: {
    localShow: {
      get () {
        return this.show
      },
      set (value) {
        if (!value) {
          this.closeDialog()
        }
      }
    },
    hasAgreement () {
      return !!this.agreement
    }
  },
  methods: {
    ...mapActions('courseAgreements', ['downloadScorecard']),
    async handleDownload () {
      if (!this.reservation?.id) {
        this.error = 'Reservacion no válida'
        return
      }

      this.downloading = true
      this.error = null

      try {
        await this.downloadScorecard(this.reservation.id)
        this.closeDialog()
      } catch (err) {
        if (err.response?.status === 500) {
          this.error = 'No se puede generar PDF. Contacta al administrador para instalar reportlab.'
        } else {
          this.error = 'Error descargando carta de salida: ' + err.message
        }
      } finally {
        this.downloading = false
      }
    },
    closeDialog () {
      this.$emit('close')
    },
    formatDate (date) {
      if (!date) return '--'
      return new Date(date).toLocaleDateString('es-ES', {
        weekday: 'long',
        day: '2-digit',
        month: 'long',
        year: 'numeric'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.agreement-info {
  background: #f5f5f5;
  padding: 12px;
  border-radius: 4px;

  .field {
    margin-bottom: 8px;
    font-size: 13px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: #0066cc;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
